module.exports = __webpack_public_path__ + "img/die-grünen-logo.1f3acabf.png";